import React, { Fragment, useState, useEffect } from "react";
import { connect } from 'react-redux';
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    CardTitle
} from "reactstrap";
import { ChromePicker } from 'react-color';
import classnames from "classnames";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import { NotificationManager } from "../../../../components/common/react-notifications";
import { API_CopyTemplate_Integration, gAPI_QuestionSets, gAPI_DynmicQuestionSetsTemplate, postAPI_Create_QuestionSet } from "../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../helpers/AxiosAPI";
import { setBackGroundColor } from '../integration/style/DigitalAssistantStyle';
import sync_template from '../../../../assets/Sync_myma.png';
import AiVoiceChannel from './components/AiVoiceChannel';
import AiEmailAssistant from './components/AiEmailAssistant';

const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;
const defaultWidgetSettings = {
    isWeb: false,
    isMessengerX: false,
    isAssistantMenu: false,
    isHelpItem: false,
    isForm: false,
    isFAQ: false,
    isConversationFlow: false,
    messengerTheme: "",
    dynamicFlowId: null,
};
function Templates({ propertyId, locale }) {

    const [apiTemplate, setApiTemplate] = useState("default");
    const [step, setStep] = useState("intro");

    const [templateData, setTemplateData] = useState({
        fromGroupId,
        fromPropertyId,
        toPropertyId: propertyId,
        toGroupId: getGroupID(),
        isForm: true,
        isHelpItem: true,
        isWeb: true,
        isMessengerX: true,
        isAssistantMenu: true,
        isFAQ: false,
        isMessengerGroupX: false,
        isEmail: false,
        isAiVoice: false,
        isConversationFlow: true,
        dynamicFlowId: null,
        messengerTheme: "WebWidgetMenus",
        appearance: null,
    });

    const [appearanceData, setAppearanceData] = useState({
        primaryColor: "#424344",
        staticColor: "#000",
        contrastColor: "white"
    });
    let [iseditMode, setEditMode] = useState({ primaryColor: false, staticColor: false, });
    const [edit, setEdit] = useState(true);
    const [error, setError] = useState(true);
    const [dynamicList, setDynamicList] = useState([]);
    const [assistantList, setAssistantList] = useState([]);
    const [isSuccess, setIsSuccess] = useState(false);
    const [assistantId, setAssistantId] = useState('');
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_DynmicQuestionSetsTemplate}/?propertyId=${fromPropertyId}&groupId=${fromGroupId}&lang=${locale}`,
        })
            .then((res) => {
                const setlist = res.data.sets.map((set) => ({
                    ...set,
                    showMore: false,
                }));

                const sortedList = setlist.sort(
                    (a, b) => a.displayOrder - b.displayOrder
                );
                setDynamicList(sortedList);
                const list = sortedList
                    .filter(
                        (l) =>
                            l.type === 'DynamicConversationFlow' &&
                            l.openAiAssistantId !== ''
                    )
                    .map((l) => ({
                        id: l.id,
                        name: l.name,
                        openAiAssistantId: l.openAiAssistantId,
                    }));

                setAssistantList(list);
            })
            .catch((err) => {
                console.error(
                    'API error:',
                    err.response ? err.response.data : err.message
                );
            });
    }, [fromPropertyId, fromGroupId, locale]);

    useEffect(() => {
        if (templateData.messengerTheme === "WebWidgetMenus") {
            setTemplateData(prev => ({
                ...prev,
                isHelpItem: true,
            }));
        } else if (templateData.messengerTheme === "ChatSuggestions") {
            setTemplateData(prev => ({
                ...prev,
                isHelpItem: false,
            }));
        }
    }, [templateData.messengerTheme]);
    const updateTemplateData = (key, value) => {
        console.log('id', value)
        setTemplateData(prev => ({ ...prev, [key]: value }));
    };

    const ClickGetStarted = () => setStep("color");
    const ClickNext = () => setStep("next");
    const ClickEnd = () => setStep("thankyou");
    const ClickAiVoice = () => {
        setTemplateData(prev => ({
            ...prev,
            ...defaultWidgetSettings,
        }));

        setStep("aiVoice");
        setIsSuccess(false);

    };

    const ClickEmailAssistant = () => {
        setTemplateData(prev => ({
            ...prev,
            ...defaultWidgetSettings,
        }));
        setStep("emailAssistant");
        setIsSuccess(false);
    }

    const createQuestionSetFromTemplate = async () => {
        const templateFlow = dynamicList.find(
            (flow) => flow.openAiAssistantId === templateData.dynamicFlowId
        );

        if (!templateFlow) return null;

        const payload = {
            GroupId: getGroupID(),
            PropertyId: propertyId === "-1" ? null : propertyId,
            Name: templateFlow.name,
            Description: templateFlow.description || "",
            Instructions: templateFlow.instructions || "",
            Type: "DynamicConversationFlow",
            Status: "Active",
            IsGroupVisible: templateFlow.isGroupVisible ?? false,
            OpenAiModel: templateFlow.openAiModel,
            OpenAiReasoningEfforts: null,
            OpenAiVerbosity: templateFlow.openAiVerbosity,
            FlowTrainingData: templateFlow.flowTrainingData,
            FlowInvokeApi: templateFlow.flowInvokeApi,
            languageCode: locale,
            Creator: "Wizard",
            publishConversationFlow: false,
        };

        try {
            const res = await AxiosAPI({
                method: "post",
                url: postAPI_Create_QuestionSet,
                data: payload,
            });

            return {
                flowId: res?.data?.id || null,
                assistantId: res?.data?.openAiAssistantId || null,
            };

        } catch (error) {
            console.error("Failed to create Dynamic Conversation Flow", error);
            return null;
        }
    };
    const getSuccessMessage = () => {
        switch (step) {
            case "next":
                return "Web Widget created successfully";
            case "aiVoice":
                return "Voice AI channel created successfully";
            case "emailAssistant":
                return "AI Email Assistant created successfully";
            default:
                return "Channel created successfully";
        }
    };

    const handleSubmit = async () => {
        setApiTemplate("processing");

        let dynamicFlowIdToUse = templateData.dynamicFlowId;

        const newFlowId = await createQuestionSetFromTemplate();

        if (newFlowId) {
            dynamicFlowIdToUse = newFlowId?.assistantId;
            setTemplateData((prev) => ({
                ...prev,
                dynamicFlowId: newFlowId.assistantId,
            }));
        }

        let payload = {
            fromGroupId: templateData.fromGroupId,
            fromPropertyId: templateData.fromPropertyId,
            toPropertyId: templateData.toPropertyId,
            toGroupId: templateData.toGroupId,
            appearance: appearanceData,
            dynamicFlowId: dynamicFlowIdToUse,
        };

        if (step === "next") {
            payload = {
                ...payload,
                isWeb: true,
                isMessengerX: true,
                isAssistantMenu: true,
                isFAQ: false,
                isMessengerGroupX: false,
                isAiVoice: false,
                isEmail: false,
                isConversationFlow: Boolean(dynamicFlowIdToUse),
                isHelpItem: templateData.isHelpItem,
                isForm: templateData.isForm,
                messengerTheme: templateData.messengerTheme,
            };
        }

        if (step === "aiVoice") {
            payload = {
                ...payload,
                isAiVoice: true,
                isConversationFlow: Boolean(dynamicFlowIdToUse),
            };
        }

        if (step === "emailAssistant") {
            payload = {
                ...payload,
                isEmail: true,
                isConversationFlow: Boolean(dynamicFlowIdToUse),
            };
        }
        try {
            const res = await AxiosAPI({
                method: "post",
                url: API_CopyTemplate_Integration,
                data: payload,
            });
            NotificationManager.success(
                "",
                getSuccessMessage(),
                5000
            );

            setIsSuccess(true);
        } catch (error) {
            console.error(error);
            NotificationManager.error("", "Something went wrong", 3000);
        }
    };


    console.log('row', assistantList,)
    return (
        <Fragment >
            <Row className=" mt-3 mb-2">
                <Colxx xxs="12">
                    <CardTitle>
                        <b>
                            Set up channels effortlessly via the wizard
                        </b>
                        <br />
                        Get started fast with wizards for Web Widget, Email Automation, and Voice AI—everything is fully editable afterwards.
                    </CardTitle>
                </Colxx>

                <Card style={{ width: "90%", borderRadius: "1.25rem", marginTop: "20px", marginLeft: "10px", marginBottom: "20px" }}>
                    <CardBody>

                        <Colxx md="12" className="mt-2 mb-3">
                            <img
                                src={sync_template}
                            // style={{ width: '100%', height: '90px' }}
                            ></img>
                        </Colxx>
                        {step === "intro" && (
                            <Fragment>
                                <Colxx sm={12} className="mb-2 ml-2">
                                    <h5 className="mb-2">To unlock the full potential of AI, you can quickly set up the channels:</h5>
                                    <ul className="ml-4 mt-2" style={{ fontSize: '14px' }}>
                                        <li>Web Widget for website and booking engine</li>
                                        <li>Voice AI</li>
                                        <li>AI Email Assistant</li>
                                    </ul>

                                    <h7 className="mb-2 mt-2"><b>Save time by using wizards to setup channels for you. You can later change or customize every aspect you like.</b></h7>

                                </Colxx>
                                <Colxx xxs="12" className="mb-4 mt-4 text-right">
                                    <Button
                                        color="secondary"
                                        size="lg"
                                        outline
                                        className=" mr-1"
                                        onClick={ClickGetStarted}
                                    >
                                        Get Started
                                    </Button>
                                </Colxx>
                            </Fragment>
                        )}

                        {/* ---------- COLOR STEP ---------- */}
                        {step === "color" && (
                            <Colxx sm={12} className="mb-2 ml-2">
                                <h5>Select your primary website/brand colors.</h5>
                                <Row>
                                    <Colxx md={4}>
                                        <div>
                                            <div className='row mb-2 mt-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                                                    <span className='' style={{ fontSize: "14px" }}>Primary Color​</span>
                                                </div>
                                                <div className='col-md-12 mt-2'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                setAppearanceData({ ...appearanceData, primaryColor: e.target.value });
                                                            }}
                                                            value={appearanceData.primaryColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                                            }}
                                                                className="color-square" style={setBackGroundColor(appearanceData.primaryColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.primaryColor && <div className='parent-div'>
                                            <div className='cover ' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '200px' }}
                                                    color={appearanceData.primaryColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            setAppearanceData({ ...appearanceData, primaryColor: e.hex });
                                                            setEditMode({ ...iseditMode, primaryColor: false });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx sm={4} className="mt-3 ml-3">
                                        <Label style={{ fontSize: "14px" }}>Contrast Text Color</Label>
                                        <div className="d-flex mt-2">
                                            <CustomInput
                                                type="radio"
                                                id="white"
                                                value={"white"}
                                                onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                                                checked={appearanceData.contrastColor === "white" ? true : false}
                                            >White</CustomInput>
                                            <CustomInput
                                                className="ml-2"
                                                type="radio"
                                                id="black"
                                                value={"black"}
                                                onChange={(e) => setAppearanceData({ ...appearanceData, contrastColor: e.target.value })}
                                                checked={appearanceData.contrastColor === "black" ? true : false}
                                            >Black</CustomInput>
                                        </div>
                                    </Colxx>
                                    <Colxx xxs="12" className="mb-4 mt-4 text-right">
                                        <Button
                                            color="secondary"
                                            size="lg"
                                            outline
                                            className=" mr-1"
                                            onClick={ClickNext}
                                        >
                                            Next
                                        </Button>
                                    </Colxx>
                                </Row>
                            </Colxx>
                        )
                        }

                        {/* ---------- WEB WIDGET SETUP ---------- */}
                        {step === "next" && (
                            <Fragment>
                                <Colxx sm={12} className="mb-2 ml-2">
                                    <h5 className="mb02">Setup Web Widget</h5>

                                    <FormGroup className="mt-4">
                                        <CustomInput
                                            type="checkbox"
                                            id="isWeb"
                                            checked={true}
                                            disabled
                                            title=" This option is required for Web Widget setup and cannot be disabled."
                                        >
                                            Chatbot for website
                                        </CustomInput>
                                    </FormGroup>

                                    <FormGroup>
                                        <CustomInput
                                            type="checkbox"
                                            id="isMessengerX"
                                            checked={true}
                                            disabled
                                            title=" This option is required for Web Widget setup and cannot be disabled."
                                        >
                                            Web Widget for website
                                        </CustomInput>
                                    </FormGroup>

                                    <FormGroup>
                                        <CustomInput
                                            type="checkbox"
                                            id="isAssistantMenu"
                                            checked={true}
                                            disabled
                                            title=" This option is required for Web Widget setup and cannot be disabled."
                                        >
                                            Default welcome message
                                        </CustomInput>
                                    </FormGroup>

                                </Colxx>

                                <Colxx sm={12} className="mb-2">
                                    <h5>Select Theme</h5>
                                    <Input className="w-40 mt-2"
                                        type="select"
                                        name="messengerTheme"
                                        value={templateData.messengerTheme}
                                        onChange={(e) => updateTemplateData("messengerTheme", e.target.value)}
                                    >
                                        <option value='WebWidgetMenus' >Web Widget with Menus (Standard Size)</option>
                                        <option value='ChatSuggestions'>Web Widget with Suggested Questions</option>
                                    </Input>
                                </Colxx>
                                <Colxx sm={12} className="mb-2 mt-2">
                                    <Label style={{ fontSize: "14px" }}>Select the templetes you want to copy</Label>
                                    <FormGroup>
                                        <CustomInput
                                            type="checkbox"
                                            id="isHelpItem"
                                            // onChange={(e) => setTemplateData({ ...templateData, isHelpItem: e.target.checked })}
                                            onChange={(e) => updateTemplateData("isHelpItem", e.target.checked)}
                                            checked={templateData.isHelpItem}
                                        >Common help items</CustomInput>
                                    </FormGroup>
                                    <FormGroup>
                                        <CustomInput
                                            type="checkbox"
                                            id="isForm"
                                            onChange={(e) => updateTemplateData("isForm", e.target.checked)}
                                            checked={templateData.isForm}
                                        >Common Forms</CustomInput>
                                    </FormGroup>


                                    {/* <FormGroup>
                                        <CustomInput
                                            type="checkbox"
                                            name="isFAQ"
                                            id="isFAQ"
                                        onChange={(e) => updateTemplateData("isFAQ", e.target.checked)}
                                            checked={templateData.isFAQ}
                                        > FAQ’s
                                        </CustomInput>
                                    </FormGroup> */}
                                </Colxx>


                                {assistantList && assistantList.length > 0 && (
                                    <Colxx xxs="12" className="mb-2">
                                        <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>
                                        <Input className="w-40"
                                            type="select"
                                            name="dynamicConversationFlow"
                                            placeholder="Dynamic Conversation Flow"
                                            value={templateData.dynamicFlowId || ""}
                                            onChange={(e) => updateTemplateData("dynamicFlowId", e.target.value || null)}
                                        >
                                            <option value="">
                                                Select a Dynamic Conversation Flow
                                            </option>
                                            {assistantList.map((assist, index) => (
                                                <option key={index} value={assist.openAiAssistantId}>
                                                    {assist.name} ({assist.openAiAssistantId})
                                                </option>
                                            ))}
                                        </Input>
                                    </Colxx>
                                )}


                                <Colxx xxs="12" className="mb-4 mt-4 text-right">
                                    {isSuccess ?
                                        <Button
                                            color="primary"
                                            size="lg"
                                            outline
                                            className=" mr-1"
                                            onClick={ClickAiVoice}
                                        >
                                            Next
                                        </Button>
                                        :
                                        <div>
                                            <Button
                                                color="secondary"
                                                size="lg"
                                                outline
                                                className=" mr-2"
                                                onClick={ClickAiVoice}
                                            >
                                                Skip
                                            </Button>

                                            <Button
                                                color="primary"
                                                size="lg"
                                                outline
                                                className=" mr-1"
                                                onClick={handleSubmit}
                                            >
                                                Create Web Widget
                                            </Button>
                                        </div>
                                    }
                                </Colxx>
                            </Fragment>
                        )}

                        {/* ---------- AI VOICE STEP ---------- */}
                        {step === "aiVoice" && (
                            <AiVoiceChannel
                                templateData={templateData}
                                updateTemplateData={updateTemplateData}
                                assistantList={assistantList}
                                clickAiEmail={ClickEmailAssistant}
                                submit={handleSubmit}
                                isSuccess={isSuccess}
                            />
                        )}

                        {/* ---------- EMAIL ASSISTANT STEP ---------- */}
                        {step === "emailAssistant" && (
                            <AiEmailAssistant
                                templateData={templateData}
                                updateTemplateData={updateTemplateData}
                                assistantList={assistantList}
                                clickEnd={ClickEnd}
                                submit={handleSubmit}
                                isSuccess={isSuccess}
                            />
                        )}
                        {step === "thankyou" && (
                            <div className="item-center mt-4 mb-4">
                                <h1 className="mt-4 mb-4">Thank You!</h1>
                            </div>
                        )}
                        <Colxx sm={12} className="d-none">
                            <Button
                                color="primary"
                                onClick={handleSubmit}
                                className={`btn-multiple-state ${classnames({
                                    "show-spinner": apiTemplate === "processing",
                                    "show-success": apiTemplate === "success",
                                    "show-fail": apiTemplate === "fail"
                                })}`}
                            >
                                <span className="spinner d-inline-block">
                                    <span className="bounce1" />
                                    <span className="bounce2" />
                                    <span className="bounce3" />
                                </span>
                                <span className="icon success">
                                    <i className="simple-icon-check" />
                                </span>
                                <span className="icon fail">
                                    <i className="simple-icon-exclamation" />
                                </span>
                                <span className="label">Import</span>
                            </Button>
                        </Colxx>
                    </CardBody>
                </Card>
            </Row>
        </Fragment>
    );
}

/* Redux */
const mapStateToProps = ({ settings }) => {
    return {
        propertyId: settings.propertyId,
        locale: settings.locale,
    };
};

export default connect(mapStateToProps)(Templates);
